const dataLanguage = {
  en: {
    "bss-fl-guest-header": "Access to the Dealer Area",
    "bss-fl-guest-description-1": "Log in here to view products and prices.",
    "bss-fl-guest-description-2": "or",
    "bss-fl-guest-button-1": "To the Retail Customer Area",
    "bss-fl-logged-header": "Notice",
    "bss-fl-logged-description-1":
      "This online shop is exclusively for dealers. Products will only be displayed after successful verification and activation.",
    "bss-fl-logged-description-2": "To register, please send an email to",
    "bss-fl-logged-description-3": "or use the chat window in the bottom left.",
  },
  es: {
    "bss-fl-guest-header": "Acceso al área de distribuidores",
    "bss-fl-guest-description-1":
      "Inicia sesión aquí para ver productos y precios.",
    "bss-fl-guest-description-2": "o",
    "bss-fl-guest-button-1": "Al área de clientes minoristas",
    "bss-fl-logged-header": "Aviso",
    "bss-fl-logged-description-1":
      "Esta tienda en línea es exclusivamente para distribuidores. Los productos se mostrarán solo después de una verificación y activación exitosas.",
    "bss-fl-logged-description-2":
      "Para registrarse, por favor envíe un correo electrónico a",
    "bss-fl-logged-description-3":
      "o utilice la ventana de chat en la esquina inferior izquierda.",
  },
};
let language = "de";
if (window.location.pathname.includes("/en")) {
  language = "en";
} else if (window.location.pathname.includes("/es")) {
  language = "es";
}
document.addEventListener("DOMContentLoaded", (event) => {
  const bssFlContainer = document.querySelector(".bss-fl-container");
  if (bssFlContainer) {
    const content = dataLanguage[language];
    Object.keys(content).forEach((key) => {
      const element = document.querySelector("." + key);
      if (element) {
        element.innerText = content[key];
      }
    });
  }
});
